/* Progressive enhancement only. The native GET form remains usable without JS. */
(() => {
  const bind = scope => {
    scope.querySelectorAll('[data-r11-landing]').forEach(page => {
      if (page.dataset.r11Ready) return;
      page.dataset.r11Ready = 'true';
      const form = page.querySelector('[data-r11-choice]');
      if (!form) return;
      const price = page.querySelector('[data-r11-price]');
      const color = page.querySelector('[data-r11-color]');
      form.addEventListener('change', event => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'variant' || !input.checked || input.disabled) return;
        if (price && input.dataset.r11PriceValue) price.textContent = input.dataset.r11PriceValue;
        if (color && input.dataset.r11ColorValue) color.textContent = input.dataset.r11ColorValue;
      });
      // Deliberately no submit interceptor, fetch, storage, pixel or cart mutation.
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document), {once:true});
  else bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
